export enum ResumeType {
  Standard = 'standard',
  Veterans = 'veterans'
}
